import * as Vue from "vue";
import * as mutations from "../../mutation-types"
import _ from "lodash"
import axios from "axios";


export const processUser = (store, user) => {
    if (user.proposals) {
        _.each(user.proposals, proposal => store.dispatch('processProposal', proposal))
        delete(user.proposals)
    }

    if (user.projects) {
        _.each(user.projects, project => store.dispatch('processProject', project))
        delete(user.projects)
    }

    if (user.hourly_rates) {
        _.each(user.hourly_rates, rate => store.dispatch('processHistoricalData', rate))
        delete(user.hourly_rates)
    }

    if (user.followed_projects) {
        _.each(user.followed_projects, followedProject => store.dispatch('processFollowedProject', followedProject))
        delete(user.followedProjects)
    }

    store.commit(mutations.ADD_OR_UPDATE_USER, user)
};

export const createUser = (store, user = {}) => {
    return axios.post(`/api/users`, user)
        .then(response => {
            store.commit(mutations.ADD_OR_UPDATE_USER, response.data.data)
            return response
        });
};

export const fetchUsers = (store, params) => {
    return axios.get(`/api/users`, { params })
        .then(res => {
            _.each(res.data.data, item => processUser(store, item))
            return res
        })
}

export const updateUser = (store, user = {}) => {
    return axios.patch(`/api/users/${user.id}`, user)
        .then(response => {
            store.commit(mutations.ADD_OR_UPDATE_USER, response.data.data)
            return response
        });
}

export const updateUserServicesReminder = (store, user = {}) => {
    return axios.patch(`/api/users/${user.id}/update-services-reminder`, user)
        .then(response => {
            processUser(store, response.data.data)
            return response
        });
}

export const updateUserServicesView = (store, user = {}) => {
    return axios.patch(`/api/users/${user.id}/update-services-view`, user)
        .then(response => {
            processUser(store, response.data.data)
            return response
        });
}

export const updateCurrentUserServicesReminder = (store, user = {}) => {
    user.id = store.rootState.auth.currentUserId;
    return updateUserServicesReminder(store, user)
}

export const updateCurrentUserServicesView = (store, user = {}) => {
    user.id = store.rootState.auth.currentUserId;
    return updateUserServicesView(store, user)
}

export const simpleUpdateUser = (store, user = {}) => {
    return axios.patch(`/api/users/${user.id}/simple`, user)
        .then(response => {
            store.commit(mutations.ADD_OR_UPDATE_USER, response.data.data)
            return response
        });
}

export const updateFollowedFrequency = (store, user = {}) => {
    return axios.patch(`/api/followed-projects/${user.id}/update`, user)
        .then(response => {
            store.commit(mutations.ADD_OR_UPDATE_USER, response.data.data)
            return response
        });
}

export const createOrUpdateUser = (store, item) => {
    return item.id ?
        updateUser(store, item) :
        createUser(store, item)
}

export const updateAvatar = (store, params) => {
    return axios.post(`/avatar`, { params })
        .then(res => {
            store.commit(mutations.ADD_OR_UPDATE_USER, res.data.data)
            return res
        });
}

export const deleteAvatar = (store, userId) => {
    return axios.delete('/avatar', { userId })
        .then(res => {
            store.commit(mutations.ADD_OR_UPDATE_USER, res.data.data)
            return res
        })
}

export const updateCurrentUser = (store, user = {}) => {
    user.id = store.rootState.auth.currentUserId;
    return updateUser(store, user)
};

export const updateCurrentUserAuthSettings = (store, payload) => {
    let userId = store.rootState.auth.currentUserId;

    return axios.patch(`/api/users/${userId}/auth-settings`, payload)
        .then(res => {
            store.commit(mutations.ADD_OR_UPDATE_USER, res.body.data)
            return res;
        }).catch(res => {
            if (res.body.error) {
                swal({
                    title: "Error occurred",
                    text: res.body.error,
                    type: 'error'
                });
            }
            throw res;
        });
};

export const updatePassword = (store, payload) => {
    return axios.post(`/api/users/${payload.id}/passwords`, payload)
};

export const fetchUserById = (store, id) => {
    return axios.get(`/api/users/${id}`).then(response => {
        processUser(store, response.data.data)
        return response
    })
};

export const fetchCurrentUser = (store) => {
    if(!store.rootState.auth.currentUserId) return null;
    return fetchUserById(store, store.rootState.auth.currentUserId)
};

export const removeUser = (store, item) => {
    return axios.delete(`/api/users/${item.id}`)
        .then(res => {
            store.commit(mutations.REMOVE_USER, item)
            return res
        })
}

export const createUserReview = (store, { user = {}, review }) => {
    return axios.post(`/api/users/${user.id}/reviews`, review)
        .then(response => {
            return response
        });
};

export const getUserReviews = (store, user = {}) => {
    return axios.get(`/api/users/${user.id}/reviews`)
        .then(response => {
            return response
        });
};

export const getUserTimelogs = (store, params ) => {
    return axios.get(`/api/users/${params.users[0]}/timelogs`, { params } )
        .then(response => {
            return response
        });
};

export const getBillingGrouped = (store, params ) => {
    return axios.get(`/api/billings/grouped`, { params } )
        .then(response => {
            return response
        });
};

export const getNonbillablevalue = (store, params ) => {
    return axios.get(`/api/users/${params.users[0]}/nonbillablevalue`, { params } )
        .then(response => {
            return response
        });
};



export const toggleBillingsReimb = store => {
    let visible = store.getters.isBillingReimbVisible
    localStorage.setItem('is_billing_reimb_visible', !visible)
    store.commit(mutations.SET_USER_SETTING, {setting: 'is_billing_reimb_visible', value: !visible} )
}